module.exports = __webpack_public_path__ + "img/palas_pickleball.70eb3a9c.jpg";